<form *ngIf="voucherOrderForm" [formGroup]="voucherOrderForm" (ngSubmit)="onSubmit(voucherOrderForm)" class="content-card">
  <mat-card class="form-card">
      <mat-card-header>
          <mat-card-title>
              <h5>Voucher Order</h5>
          </mat-card-title>
      </mat-card-header>
    <mat-card-content>
      <app-date-edit placeholder="Start date" formControlName="startDate" [min]="orderMinDate" required (onChanged)="newDateBoundaries($event)"></app-date-edit>
      <app-date-edit #expireDate placeholder="Expiry date" formControlName="expireDate"  [min]="orderMinDate" [max]="orderMaxDate" required ></app-date-edit>
      <mat-form-field>
        <input matInput type="number" min="1" max="200" step="1" pattern="^[0-9]*$" placeholder="Vouchers quantity" formControlName="quantity">
      </mat-form-field>

      <mat-form-field>
        <input matInput placeholder="Package Name" formControlName="packageName">
      </mat-form-field>

      <mat-form-field>
          <mat-select placeholder="Product" formControlName="productId" required>
            <mat-option *ngFor="let product of products" [value]="product.id">{{product.name}}</mat-option>
          </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Type" formControlName="voucherType" required>
          <mat-option *ngFor="let voucherType of voucherTypes" [value]="voucherType.code">{{voucherType.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="this.voucherOrderForm.value.voucherType === 1">
        <mat-form-field>
          <input matInput type="number" min="1" max="200" step="1" pattern="^[0-9]*$" placeholder="Fixed Amount" formControlName="fixedAmount">
        </mat-form-field>
      </div>

    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!voucherOrderForm.valid">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
